import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import {TopInputDate} from "../../../../../componentsTopsa/inputs/TopInputs";
import {TopButtonCancel, TopButtonSave} from "../../../../../componentsTopsa/buttons/TopButtons";
import DateFormat from "../../../../../utilities/DateAndTimeFormat";
import moment from "moment";
import Validator from "../../../../../utilities/Validator";
import ValidatorMessages from "../../../../../shared/validatorMessages/ValidatorMessages";
import {TopSelect} from "../../../../../componentsTopsa/selects/TopSelects";
import StalePolaTopSelect from "../../../../../utilities/utilitiesTopSelect";
import TopSelectSlownik from "../../../../../componentsTopsa/selects/TopSelectSlownik";
import AppConfig from "../../../../../AppConfig";
import PojazdyService from "../PojazdyService";
import styles from "../../../../../componentsTopsa/buttons/TopButtonsStyles";
import "./../../../../../styles/pojazdyForm.css";

export default class PojazdyForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            idPoSt: null,
            marka: '',
            model: '',
            nrRejestracji: '',
            nrNadwozia: '',
            ilosc_miejsc: '',
            dataAc: null,
            dataOc: null,
            dataBt: null,
            dataPt: null,
            idRej: '',
            certRej: '',
            wifi: '',
            status: {status: 1, label: 'dostępny'},
            uwagi: '',
            validateMessages: [],
            normaSpalania: null,
            serwis: [],
            opisSerwis: ''
        };
        this.onChangeWartosc = this.onChangeWartosc.bind(this)
        this.onChangeWartoscAndValidate = this.onChangeWartoscAndValidate.bind(this)
        this.onChangeDataAc = this.onChangeDataAc.bind(this)
        this.onChangeDataOc = this.onChangeDataOc.bind(this)
        this.onChangeDataBt = this.onChangeDataBt.bind(this)
        this.onChangeDataPt = this.onChangeDataPt.bind(this)
        this.onClickZapisz = this.onClickZapisz.bind(this)
        this.onChangeStatus = this.onChangeStatus.bind(this)
    }

    componentDidMount() {
        if (this.props.pojazd) {
            this.setState({
                idPoSt: this.props.pojazd.idPoSt,
                marka: this.props.pojazd.marka,
                model: this.props.pojazd.model,
                nrRejestracji: this.props.pojazd.nrRej,
                nrNadwozia: this.props.pojazd.nrNadw,
                ilosc_miejsc: this.props.pojazd.ileMiejsc,
                dataAc: Boolean(this.props.pojazd.dataAc) ? moment(this.props.pojazd.dataAc) : null,
                dataOc: Boolean(this.props.pojazd.dataOc) ? moment(this.props.pojazd.dataOc) : null,
                dataBt: Boolean(this.props.pojazd.dataBt) ? moment(this.props.pojazd.dataBt) : null,
                dataPt: Boolean(this.props.pojazd.dataPt) ? moment(this.props.pojazd.dataPt) : null,
                idRej: this.props.pojazd.idRej,
                certRej: this.props.pojazd.certRej,
                status: StalePolaTopSelect.returnComboboxStatusy().find(s => s.status == this.props.pojazd.status),
                uwagi: this.props.pojazd.uwagi,
                normaSpalania: this.props.pojazd.normaSpalin,
                wifi: Boolean(this.props.pojazd.wifi) ? this.props.pojazd.wifi : ''
            });

            this.pobierzSerwis(this.props.pojazd.idPo);
        }
    }

    componentWillReceiveProps(nextprops) {
        if (nextprops.pojazd) {
            this.setState({
                idPoSt: nextprops.pojazd.idPoSt,
                marka: nextprops.pojazd.marka,
                model: nextprops.pojazd.model,
                nrRejestracji: nextprops.pojazd.nrRej,
                nrNadwozia: nextprops.pojazd.nrNadw,
                ilosc_miejsc: nextprops.pojazd.ileMiejsc,
                dataAc: Boolean(nextprops.pojazd.dataAc) ? moment(nextprops.pojazd.dataAc) : null,
                dataOc: Boolean(nextprops.pojazd.dataOc) ? moment(nextprops.pojazd.dataOc) : null,
                dataBt: Boolean(nextprops.pojazd.dataBt) ? moment(nextprops.pojazd.dataBt) : null,
                dataPt: Boolean(nextprops.pojazd.dataPt) ? moment(nextprops.pojazd.dataPt) : null,
                idRej: nextprops.pojazd.idRej,
                certRej: nextprops.pojazd.certRej,
                status: StalePolaTopSelect.returnComboboxStatusy().find(s => s.status == nextprops.pojazd.status),
                uwagi: nextprops.pojazd.uwagi,
                normaSpalania: nextprops.pojazd.normaSpalin,
                wifi: Boolean(nextprops.pojazd.wifi) ? nextprops.pojazd.wifi : ''
            })
            document.getElementById('inputMarka').value = nextprops.pojazd.marka;
            document.getElementById('inputModel').value = nextprops.pojazd.model;
            document.getElementById('inputRejestracja').value = nextprops.pojazd.nrRej;
            document.getElementById('inputNadwozie').value = nextprops.pojazd.nrNadw;
            document.getElementById('inputMiejsca').value = nextprops.pojazd.ileMiejsc;
          //  document.getElementById('inputRej').value = nextprops.pojazd.idRej;
            document.getElementById('inputCert').value = nextprops.pojazd.certRej;
            document.getElementById('inputUwagi').value = nextprops.pojazd.uwagi;
            document.getElementById('inputWifi').value = nextprops.pojazd.wifi;

            this.pobierzSerwis(nextprops.pojazd.idPo);
        }
    }

    pobierzSerwis = (idPo) => {
        PojazdyService.getSerwis(idPo).then((response) => {
            this.setState({serwis: response.data});
        }).catch((e) => {
            console.log('error');
        })
    }

    onChangeStatus(e) {
        this.setState({status: e})
    }

    onChangeWartosc(wartosc, e) {
        this.state[wartosc] = e.target.value
    }

    onChangeWartoscAndValidate(wartosc, e, max, elem) {
        if (Validator.validateLenghtWithClearing(e.target.value, max, elem, this.state[wartosc])) {
            this.setState({[wartosc]: e.target.value})
        }
    }

    onChangeDataAc(e) {
        this.setState({dataAc: e})
    }

    onChangeDataOc(e) {
        this.setState({dataOc: e})
    }

    onChangeDataBt(e) {
        this.setState({dataBt: e})
    }

    onChangeDataPt(e) {
        this.setState({dataPt: e})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validateMessages;
        arr.push(msg)
        this.setState({validateMessages: arr})
    }

    onClickZapisz() {

        this.state.validateMessages = [];
        let poprawne = true;

        if (!Boolean(this.state.marka)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono marki pojazdu')
        }
        if (!Boolean(this.state.model)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono modelu pojazdu')
        }
        if (!Boolean(this.state.nrRejestracji)) {
            poprawne = false;
            this.dodajDoValidatorMessages('Nie uzupełniono numeru rejestracji pojazdu')
        } else {
            if (this.state.nrRejestracji.indexOf(' ') > -1) {
                poprawne = false;
                this.dodajDoValidatorMessages('Numer rejestracji nie można posiadać spacji!')
            }
        }
        if (Boolean(this.state.ilosc_miejsc)) {
            if (!Validator.validateInt(this.state.ilosc_miejsc, false)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Niepoprawna ilość miejsc - wymagana liczba całkowita')
            }
        }

        /*if (Boolean(this.state.idRej)) {
            if (!Validator.validateInt(this.state.idRej, false)) {
                poprawne = false;
                this.dodajDoValidatorMessages('Niepoprawna wartość ID REJ - wymagana liczba całkowita')
            }
        }*/

        if (poprawne) {
            this.setState({validateMessages: []});

            let date = {
                "idPoSt":this.state.idPoSt,
                "marka": this.state.marka,
                "model": this.state.model,
                "ileMiejsc": this.state.ilosc_miejsc,
                "nrRej": this.state.nrRejestracji,
                "dataBt": DateFormat.formatYYYYMMDD(this.state.dataBt),
                "dataPt": DateFormat.formatYYYYMMDD(this.state.dataPt),
                "nrNadw": this.state.nrNadwozia,
                "certRej": this.state.certRej,
                "idRej": this.state.idRej,
                "uwagi": this.state.uwagi,
                "status": this.state.status.status,
                "dataAc": DateFormat.formatYYYYMMDD(this.state.dataAc),
                "dataOc": DateFormat.formatYYYYMMDD(this.state.dataOc),
                "normaSpalin": this.state.normaSpalania,
                "wifi": this.state.wifi
            }

            if (Boolean(this.props.pojazd)) {
                // edycja
                this.props.handleClickZapisz(date, true)
            }
            else {
                this.props.handleClickZapisz(date, false)
            }
        }
    }

    onClickZapiszSerwis = (e) => {
        e.preventDefault();
        let id = this.props.pojazd.idPo;

        PojazdyService.addSerwis(id, this.state.opisSerwis).then((response) => {
            this.setState({opisSerwis: ''});
            this.pobierzSerwis(id);
        }).catch((e) => {
            console.log('error');
        })
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>{Boolean(this.props.pojazd) ? 'Edycja pojazdu' : 'Nowy pojazd'}</div>
                    <Form horizontal={true} className={'horizontal-form'}>
                        <Row>
                            <Col xs={12} lg={6}>
                                <FormGroup>
                                    <h6>Dane o pojeździe</h6>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Marka <span className={'req'}>*</span> <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.marka.length}/20 znaków</span>
                                        </ControlLabel>
                                        <FormControl onChange={(e) => this.onChangeWartoscAndValidate('marka', e, 20, 'inputMarka')}
                                                     defaultValue={Boolean(this.props.pojazd) ? this.props.pojazd.marka : ''} id={'inputMarka'}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Model <span className={'req'}>*</span> <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.model.length}/30 znaków</span>
                                        </ControlLabel>
                                        <FormControl onChange={(e) => this.onChangeWartoscAndValidate('model', e, 30, 'inputModel')}
                                                     defaultValue={Boolean(this.props.pojazd) ? this.props.pojazd.model : ''} id={'inputModel'}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Nr rejestracji <span className={'req'}>*</span> <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.nrRejestracji.length}/10 znaków</span>
                                        </ControlLabel>
                                        <FormControl onChange={(e) => this.onChangeWartoscAndValidate('nrRejestracji', e, 10, 'inputRejestracja')}
                                                     defaultValue={Boolean(this.props.pojazd) ? this.props.pojazd.nrRej : ''}
                                                     id={'inputRejestracja'}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Nr nadwozia <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.nrNadwozia.length}/30 znaków</span>
                                        </ControlLabel>
                                        <FormControl onChange={(e) => this.onChangeWartoscAndValidate('nrNadwozia', e, 30, 'inputNadwozie')}
                                                     defaultValue={Boolean(this.props.pojazd) ? this.props.pojazd.nrNadw : ''} id={'inputNadwozie'}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Ilość miejsc
                                        </ControlLabel>
                                        <FormControl onChange={(e) => this.onChangeWartosc('ilosc_miejsc', e)}
                                                     defaultValue={Boolean(this.props.pojazd) ? this.props.pojazd.ileMiejsc : ''}
                                                     id={'inputMiejsca'}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <h6>Numer WIFI w pojeździe</h6>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Numer WIFI <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.wifi.length}/50 znaków</span>
                                        </ControlLabel>
                                        <FormControl onChange={(e) => this.onChangeWartoscAndValidate('wifi', e, 50, 'inputWifi')}
                                                     defaultValue={Boolean(this.props.pojazd) ? this.props.pojazd.wifi : ''} id={'inputWifi'}/>
                                    </Col>
                                </FormGroup>
                                {Boolean(this.props.pojazd) &&
                                <div>
                                    <FormGroup>
                                        <h6>Serwis pojazdu</h6>
                                        <Col xs={12}>
                                            <ControlLabel>
                                                Opis serwisu
                                            </ControlLabel>
                                            <FormControl onChange={(e) => this.setState({opisSerwis: e.target.value})}
                                                         value={this.state.opisSerwis}
                                                         defaultValue={Boolean(this.state.opisSerwis) ? this.state.opisSerwis : ''}
                                                         id={'inputSerwis'} className={'inSerwis'}/>
                                            <button onClick={(e) => this.onClickZapiszSerwis(e)}
                                                    className={'btnZapiszSerwis'}><i
                                                className='fa fa-lg fa-save'/> Dodaj
                                            </button>
                                        </Col>
                                    </FormGroup>
                                    <FormGroup>
                                        <Col xs={12} className={'labelHistoria'}>
                                            <ControlLabel>
                                        <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal',
                                        }}>Historia serwisu</span>
                                            </ControlLabel>
                                            <div className={'serwis'}>
                                                {(this.state.serwis.length > 0) ?
                                                    <ul>
                                                        {this.state.serwis.sort((a, b) => b.idPoSerwis - a.idPoSerwis).map((s) => {
                                                            return <li>
                                                                <b>[{moment(s.dataWpisu).format('YYYY-MM-DD HH:mm')}]</b> - {s.opis}
                                                            </li>
                                                        })}
                                                    </ul>
                                                    :
                                                    <h6>Brak historii</h6>
                                                }
                                            </div>
                                        </Col>
                                    </FormGroup>
                                </div>
                                }
                            </Col>
                            <Col xs={12} lg={6}>
                                <FormGroup>
                                    <h6>Dane o dokumentach</h6>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Data AC
                                        </ControlLabel>
                                        <TopInputDate onChange={this.onChangeDataAc} value={this.state.dataAc}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Data OC
                                        </ControlLabel>
                                        <TopInputDate onChange={this.onChangeDataOc} value={this.state.dataOc}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Data badania technicznego
                                        </ControlLabel>
                                        <TopInputDate onChange={this.onChangeDataBt} value={this.state.dataBt}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Data przeglądu tachografu
                                        </ControlLabel>
                                        <TopInputDate onChange={this.onChangeDataPt} value={this.state.dataPt}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <h6>Pozostałe informacje</h6>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Norma spalania
                                        </ControlLabel>

                                        <TopSelectSlownik restUrl={AppConfig.HOST_API() + 'slownik/byNazwa/NORMA_SPALIN'}
                                                          onChange={(e) => {
                                                              this.setState({
                                                                  normaSpalania: Boolean(e) ? e.wartosc : null
                                                              })
                                                          }}
                                                          valueKey={'id'} labelKey={'wartosc'}
                                                          defaultValue={this.state.normaSpalania}
                                        />
                                    </Col>
                                    {/*<Col xs={12}>
                                        <ControlLabel>
                                            ID rej
                                        </ControlLabel>
                                        <FormControl onChange={(e) => this.onChangeWartosc('idRej', e)}
                                                     defaultValue={Boolean(this.props.pojazd) ? this.props.pojazd.idRej : ''} id={'inputRej'}/>
                                    </Col>*/}
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Cert rej <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.certRej.length}/10 znaków</span>
                                        </ControlLabel>
                                        <FormControl onChange={(e) => this.onChangeWartoscAndValidate('certRej', e, 10, 'inputCert')}
                                                     defaultValue={Boolean(this.props.pojazd) ? this.props.pojazd.certRej : ''} id={'inputCert'}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Status
                                        </ControlLabel>
                                        <TopSelect onChange={this.onChangeStatus} value={this.state.status}
                                                   options={StalePolaTopSelect.returnComboboxStatusy()} labelKey={'label'} valueKey={'status'}
                                                   clearable={false}/>
                                    </Col>
                                    <Col xs={12}>
                                        <ControlLabel>
                                            Uwagi <span style={{
                                            fontSize: '12px',
                                            color: 'grey',
                                            fontStyle: 'italic',
                                            fontWeight: 'normal'
                                        }}>{this.state.uwagi.length}/120 znaków</span>
                                        </ControlLabel>
                                        <FormControl onChange={(e) => this.onChangeWartoscAndValidate('uwagi', e, 120, 'inputUwagi')}
                                                     defaultValue={Boolean(this.props.pojazd) ? this.props.pojazd.uwagi : ''} id={'inputUwagi'}/>
                                    </Col>
                                    <Col xs={12}>
                                        <div className={'add-label-margin'}></div>
                                        <TopButtonCancel onClick={() => {
                                            this.props.handleClickAnuluj()
                                        }} text={'Anuluj'}/>
                                        <TopButtonSave onClick={this.onClickZapisz} text={'Zapisz'}/>
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <ValidatorMessages messages={this.state.validateMessages}/>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/zasobyConfig/pojazdy/components/PojazdyForm.js